module.exports = __webpack_public_path__ + "static/media/Uni-Student-Product-Shot_1148x934-min.6cfe8e1d.png";